import React, { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import useSWR from 'swr';
import { Loader } from '../../../../components/loader/Loader';
import { useAssetClass } from '../../../../contexts/assetClass';
import { useAuth } from '../../../../contexts/auth';
import { useBreadcrumbs } from '../../../../contexts/breadcrumbsContext';
import { useTranslation } from '../../../../contexts/translation';
import { TasksServiceDeskCreateForm } from '../../../../forms/tasks/TasksServiceDeskCreateForm';
import { PageContentWrapper } from '../../../../layouts/contentWrapper/PageContentWrapper';
import { DetailPageParams } from '../../../../types/pageParams.types';
import { Task } from '../../../../types/task.types';
import { API_URL, fetcher } from '../../../../utils/apiUrl';
import { swrConfig } from '../../../Assets/AssetsEdit';

interface TaskServiceDeskCreateState {
  customerProject: {
    customerId?: number;
    customerProjectId?: number;
    topLevelAssetId?: number;
    assetId?: number;
  }
}

export const TaskServiceDeskCreate = () => {
  const { user } = useAuth();
  const { assetClass } = useAssetClass();
  const { translate } = useTranslation();
  const { setValue } = useBreadcrumbs();
  const { id } = useParams<DetailPageParams>();
  const { state }: { state: TaskServiceDeskCreateState | undefined } = useLocation();  

  const transFormName = 'Task.CreateServiceDesk';

  // Kvůli kopii
  const { data: task, isValidating: taskValidating } = useSWR<Task>(
    id ? `${API_URL.TASK_ITEM}?id=${id}` : '',
    fetcher,
    swrConfig,
  );

  // Šalbona
  const { data: taskTemplates, isValidating: taskTemplatesValidating } = useSWR<any>(
    user ? `${API_URL.TASK_TEMPLATE_LIST}` : '',
    fetcher,
    swrConfig,
  );

  useEffect(() => {
    setValue({
      pageName: 'New task',
      steps: [
        { name: 'Home', pathToCutCount: 3 },
        { name: 'Tasks', pathToCutCount: 2 },
      ],
    });
    return () => {
      setValue(null);
    };
  }, []);

  if (!user || taskValidating || !taskTemplates || taskTemplatesValidating) return <Loader />;

  const templatesFiltered = taskTemplates.filter(
    (x) =>
      x.userId === user.personalNumber &&
      x.assetClassId === assetClass &&
      x.inboxEmail === null &&
      x.inboxFolderName === null &&
      (x.requestorEmail === null || x.requestorEmail === ''),
  );
  const taskTemplate: any = templatesFiltered.length > 0 ? templatesFiltered[0] : null;

  return (
    <PageContentWrapper
      heading={translate!('New task', transFormName)}
      loading={false}
      error={false}
    >
      <TasksServiceDeskCreateForm
        defaultValues={{
          requestorName: user.fullName,
          requestorEmail: user.email || '',
          requestorPhone: taskTemplate ? taskTemplate.requestorPhone : '',

          customerId: state && state.customerProject ? state.customerProject.customerId : (task ? task.customerId : taskTemplate ? taskTemplate.customerId : null),
          customerProjectId: state && state.customerProject  && state.customerProject.customerProjectId ? state.customerProject.customerProjectId : (task ? task.customerProjectId : taskTemplate ? taskTemplate.customerProjectId : null),
          typeId: task ? task.typeId : taskTemplate ? taskTemplate.typeId : null,
          topLevelAssetId: state && state.customerProject  && state.customerProject.topLevelAssetId ? state.customerProject.topLevelAssetId : (task ? task.assetTopLevelParenId : null),
          assetId: state && state.customerProject  && state.customerProject.assetId ? state.customerProject.assetId : (task ? task.assetId : taskTemplate ? taskTemplate.assetId : null),
          capacityCategoryId: task
            ? task.capacityCategoryId
            : taskTemplate
              ? taskTemplate.capacityCategoryId
              : null,
          responsiblePersonId: task
            ? task.responsiblePersonId
            : taskTemplate
              ? taskTemplate.responsiblePersonId
              : null,
          requiredDate: task ? task.requiredDate : null,
          taskName: task ? task.taskName : '',
          description: task ? task.description : '',
          creationTime: new Date(),
          billingStatus: task ? task.billingStatus : null,
        }}
        enableSaveTemplate
      />
    </PageContentWrapper>
  );
};
